import { QuizStateMachineAbstractState,
         QuizStateMachineCommonEvents } from '@/app/quiz-player/api'
import { ExamSessionState } from '@/app/exam-session/service'
export { QuizStateMachinePhase as ExamStateMachinePhase } from '@/app/quiz-player/api'

export abstract class ExamStateMachineAbstractState<TEvents extends QuizStateMachineCommonEvents>
      extends QuizStateMachineAbstractState<TEvents> {
}

export type ExamStateMachineCommonEvents = QuizStateMachineCommonEvents

export type ExamStartOptions = ({
  type: 'new'
} | {
  type: 'continue'
  state: ExamSessionState
}) & {
  sessionId: string
  examId: string
  aspect: string
}
